import { createTheme } from '@mui/material/styles';

/**
 * Tema light dedicado pra páginas que precisam de aparência clean (Ferramentas
 * DNS, Cargos Radius). O tema global tem `mode: 'light'` mas com
 * `background.paper: '#2B2E35'` (cinza escuro), o que resulta em Papers
 * escuros no resto do app — então essas páginas sobrepõem com este tema.
 */
const lightTheme = createTheme({
    typography: { fontFamily: ['sans-serif', 'Roboto', 'Montserrat'] },
    palette: {
        mode: 'light',
        primary:   { main: '#e01b29' },
        secondary: { main: '#7c1d8c' },
        warning:   { main: '#ed6c02' },
        info:      { main: '#0288d1' },
        error:     { main: '#aa2525' },
        success:   { main: '#2e7d32' },
        background: {
            default: '#f7f7f8',
            paper:   '#ffffff',
        },
        text: {
            primary:   '#1a1a1a',
            secondary: '#5f6368',
        },
    },
});

export default lightTheme;
